module.exports = __webpack_public_path__ + "static/media/TN-Men-Shoes.3ea74d27.svg";